<template>
  <div id="myContract">
    <div class="title">
      <van-icon size="20" name="arrow-left" @click="$router.back()" />
      <span style="color:#333; margin-left:35%; font-size:16px"> 我的协议</span>
    </div>
    <div class="privilege" v-for="item in myContractData" :key="item.orderid">
      <van-cell class="first-cell" title="订单编号" :value="item.orderid" />
      <van-cell title="订单明细" :value="item.product_desc" />
      <van-cell title="实付金额"  value="￥" >
        <template #right-icon>
          {{item.actualamount | toDecimal}}
        </template>
      </van-cell>
      <van-cell title="协议操作" value="查看协议" is-link @click="readContract(item)"  />
      <div v-if="myContractData === null" class="orderList">
        <van-empty description="暂无数据" />
      </div>
    </div>
    <!-- 合同内容 用户协议 -->
    <van-popup
      v-model="userAgreement"
      @close="closePopup"
      closeable
      close-icon="close"
      position="top"
      :style="{ height: '100%', width: '100%', backgroundColor: '#ddd' }"
    >
      <div id="word_1"></div>
      <user-agreement-pop
        :userAgreementData="userAgreementData"
        :sumMoney="sumMoney"
      >
        <img
          :src="require('@/assets/codeimg.json').signature"
          width="130px"
          height="130px"
        />
      </user-agreement-pop>

      <van-tabbar
        :border="false"
        style="
          background-color: #fff;
          diaplay: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <van-button
          style="height: 70%; width: 80%"
          type="info"
          block
          round
          size="small"
          @click="closePopup"
          >关闭</van-button
        >
      </van-tabbar>
    </van-popup>
    <!-- VIP升级协议 -->
    <van-popup
      v-model="vipUpgradeAgreement"
      @close="closePopup"
      closeable
      close-icon="close"
      position="top"
      :style="{ height: '100%', width: '100%', backgroundColor: '#F5F5F5' }"
    >
      <div id="word_2"></div>
      <VIPAgreementPop
        :userAgreementData="userAgreementData"
        :sumMoney="sumMoney"
      >
        <img
          :src="require('@/assets/codeimg.json').signature"
          width="130px"
          height="130px"
        />
      </VIPAgreementPop>
      <van-tabbar
        :border="false"
        style="
          background-color: #fff;
          diaplay: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <van-button
          style="height: 70%; width: 80%"
          type="info"
          block
          round
          size="small"
          @click="closePopup"
          >关闭</van-button
        >
      </van-tabbar>
    </van-popup>

    <!-- 新合同内容 用户协议 -->
    <van-popup
      v-model="newUserAgreementModal"
      @close="closePopup"
      closeable
      position="top"
      :style="{ height: '100%', width: '100%', backgroundColor: '#F5F5F5' }"
    >
      <div id="word_1"></div>
      <newUserAgreement
        :userAgreementData="userAgreementData"
        :sumMoney="sumMoney"
      >
        <img
          :src="require('@/assets/codeimg.json').signature"
          width="130px"
          height="130px"
        />
      </newUserAgreement>

      <van-tabbar
        :border="false"
        style="
          background-color: #fff;
          diaplay: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <van-button
          style="height: 70%; width: 80%"
          type="info"
          block
          round
          size="small"
          @click="closePopup"
          >关闭</van-button
        >
      </van-tabbar>
    </van-popup>
  </div>
</template>

<script>
import CloseButton from "@/components/common/closebutton";
import userAgreementPop from "@/components/newcommon/userAgreement";
import VIPAgreementPop from "@/components/newcommon/VIPAgreement";
import newUserAgreement from "@/components/newcommon/newUserAgreement";
import { commonToast } from "@/utils/lib/toast.js";

export default {
  data() {
    return {
      myContractData: [], // 合同数据
      userAgreementData: {}, // 点击查看合同返回的数据
      sumMoney: 0, // 合计
      userAgreement: false,
      vipUpgradeAgreement: false,
      newUserAgreementModal: false, // 新用户协议
    };
  },
  components: {
    CloseButton,
    userAgreementPop,
    VIPAgreementPop,
    newUserAgreement,
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$http
        .getOrderContractList()
        .then((res) => {
          console.log("我的合同res===>", res);
          this.myContractData = res.items;
          console.log("this.myContractData", this.myContractData);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    readContract(item) {
      console.log("查看合同", item);
      // 获取用户协议的内容
      this.$http
        .reqGetContractinfo(item.orderid)
        .then((res) => {
          console.log("获取用户协议的内容res===>", res);
          this.sumMoney = 0;
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              this.userAgreementData = res.item;
              this.userAgreementData.detail.forEach((ite) => {
                this.sumMoney += ite.amount;
              });
              if (item.ordertype >= 10 && item.ordertype <= 19) {
                // 10-19 用户协议

                if (item.mall_ver != "v1") {
                  this.newUserAgreementModal = true;
                } else {
                  this.userAgreement = true;
                }
                this.$nextTick(() => {
                  let dom = document.getElementById("word_1"); // 20-29 vip协议
                  dom.scrollIntoView();
                });
              } else if (item.ordertype >= 20 && item.ordertype <= 29) {
                this.vipUpgradeAgreement = true;
                this.$nextTick(() => {
                  let dom = document.getElementById("word_2");
                  dom.scrollIntoView();
                });
              } else {
                if (item.mall_ver != "v1") {
                  this.newUserAgreementModal = true;
                } else {
                  this.userAgreement = true;
                }
                this.$nextTick(() => {
                  let dom = document.getElementById("word_1"); // 20-29 vip协议
                  dom.scrollIntoView();
                });
              }
            } else {
              commonToast(res.rltdesc, this);
            }
          } else {
            commonToast(res.rtndesc, this);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    sendContract(item) {
      console.log("发送合同", item);
    },
    // 关闭
    closePopup() {
      this.userAgreement = false;
      this.vipUpgradeAgreement = false;
      this.newUserAgreementModal = false;
      this.sumMoney = 0;
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/styles/variable.less";
#myContract {
  background-color: #F6F6F6;
  min-height: 100%;
  .title {
    padding: 10px 0;
    background-color: #fff;
    border-top: 1px solid #ddd;
    display: flex;
    align-items: center;
  }
  .privilege {
    font-size: 0.37333rem;
    margin: 10px 0 0 0;
    .orderList {
      background-color: #fff;
      margin-bottom: 10px;
      padding: 10px 10px 12px;
      box-sizing: border-box;
      border-radius: 10px;
      .listItem {
        display: flex;
        align-items: stretch;
        margin: 6px;
        .leftWord {
          flex: 0 0 82px;
        }
        .rightWord {
          flex: 1;
          display: flex;
          align-items: flex-end;
        }
      }
    }
    
    .first-cell {
      .van-cell__titel {
        flex: 1;
      }
      .van-cell__value {
        flex: 2;
      }
    }
  }
  .userAgreementContent {
    padding: 0 10px;
    margin-bottom: 3rem;
    & > h4 {
      margin-bottom: 0;
    }
    .contentItemP {
      & > p {
        text-indent: 20px;
        margin: 0;
        margin-top: 4px;
      }
      & > h5 {
        margin: 0;
        margin-top: 4px;
      }
    }
    .marginT {
      margin-top: 20px;
    }
    .zhangStyle {
      position: relative;
      & > img {
        position: absolute;
        top: 42%;
        left: 28%;
      }
    }
  }
  /deep/.van-cell__title {
    color: #000;
    font-size: 15px;
    font-weight: 500;
  }
  /deep/.van-cell__value {
    color: #404040;
  }
}
</style>
